import { FEATURE_GIFT_WRAP } from 'constants/features';
import GiftBag from 'components/icons/GiftBag';
import { cn } from 'helpers/classnames';
import { toUSD } from 'helpers/NumberFormats';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';

interface GiftWrapIndicatorProps {
  className?: string;
  giftMessage?: string;
  giftWrapCharge?: number;
  giftWrapped?: boolean;
}

// Three variants: gift bag + message, gift bag only, or message only.
const getLabel = ({ giftMessage, giftWrapCharge, giftWrapped }: Pick<GiftWrapIndicatorProps, 'giftMessage' | 'giftWrapCharge' | 'giftWrapped'>) => {
  if (!giftWrapped) {
    return 'Gift message';
  }
  const price = toUSD(giftWrapCharge, false);
  const priceSuffix = price ? ` — ${price}` : '';
  return giftMessage ? `Gift bag with message${priceSuffix}` : `Gift bag${priceSuffix}`;
};

export const GiftWrapIndicator = ({ className, giftMessage, giftWrapCharge, giftWrapped }: GiftWrapIndicatorProps) => {
  const { isEnrolled } = useIsEnrolledInVariant({ featureFlag: FEATURE_GIFT_WRAP });

  if (!isEnrolled || (!giftWrapped && !giftMessage)) {
    return null;
  }

  return (
    <div className={cn('flex text-primary', giftMessage ? 'items-start' : 'items-center', className)}>
      <GiftBag className="mr-1 h-auto w-6 shrink-0" />
      <div className="flex flex-col">
        <span className="font-medium">{getLabel({ giftMessage, giftWrapCharge, giftWrapped })}</span>
        {giftMessage && <span className="mt-1 text-secondary">&ldquo;{giftMessage}&rdquo;</span>}
      </div>
    </div>
  );
};

export default GiftWrapIndicator;
